import { memo } from 'react';
import type { IIconProps } from '../interfaces';

const KeyIcon = (props: IIconProps) => {
  const { color = 'currentColor', height = 24, width = 24 } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.73762 12.0127C8.41249 11.2151 8.24687 10.3615 8.25011 9.50014C8.25011 8.16509 8.64599 6.86002 9.38771 5.74996C10.1294 4.63991 11.1837 3.77473 12.4171 3.26383C13.6505 2.75292 15.0077 2.61925 16.3171 2.87971C17.6265 3.14016 18.8293 3.78305 19.7733 4.72707C20.7173 5.6711 21.3602 6.87386 21.6207 8.18325C21.8811 9.49265 21.7475 10.8499 21.2366 12.0833C20.7257 13.3167 19.8605 14.371 18.7504 15.1127C17.6404 15.8544 16.3353 16.2503 15.0002 16.2503C14.1389 16.2535 13.2853 16.0879 12.4877 15.7628V15.7628L11.2502 17.0003H9.00012V19.2503H6.75008V21.5004H3V17.7503L8.73762 12.0127Z"
        stroke={color}
        strokeWidth="1.50003"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.875 8.74907C17.4964 8.74907 18 8.24538 18 7.62405C18 7.00271 17.4964 6.49902 16.875 6.49902C16.2537 6.49902 15.75 7.00271 15.75 7.62405C15.75 8.24538 16.2537 8.74907 16.875 8.74907Z"
        fill={color}
      />
    </svg>
  );
};

export default memo(KeyIcon);
